<style scoped>
  ul {
    margin: 0;
    padding: 0;
    display: inline;
    vertical-align: top;
  }

  ul li {
    position: relative;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    display: inline-block;
  }


  ul li img {
    width: 100%;
    height: 100%;
  }

   .add{
    cursor: pointer;
  }

  /*.add,  .thumbnail{*/
  /*  font-size: 28px;*/
  /*  color: #8c939d;*/
  /*  width: 178px;*/
  /*  height: 178px;*/
  /*  line-height: 178px;*/
  /*  text-align: center;*/
  /*}*/

  ul li  .actions{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0,0,0,.5);
    -webkit-transition: opacity .3s;
    transition: opacity .3s;
  }

  .actions:hover{
    opacity: 1;
  }

  .action{
    display: inline-block;
    position: static;

    right: 10px;
    top: 0;
    cursor: pointer;

    font-size: inherit;
    color: inherit;
  }

  .actions::after{
    display: inline-block;
    content: "";
    height: 100%;
    vertical-align: middle;
  }
  /*div.uploader_item .thumbnail {*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*}*/

  /*div.uploader_item .thumbnail{*/
  /*  vertical-align:middle;*/
  /*  display:inline-block;width:70px;height:70px;*/
  /*  float:left;position:relative;z-index:1;margin-left:-80px;background-color:#FFF}*/

  .add{
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    line-height: 146px;
    vertical-align: top;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    outline: 0;
  }

  .add i{
    font-size: 28px;
    color: #8c939d;
  }
</style>

<template>
  <div class="uploader">
    <input @change="onFileChange" ref="file" type="file" name="file" style="display: none">

    <ul v-if="url" >
      <li>
        <img :src="url" class="thumbnail">

        <span  class="actions">
          <span @click="removeFile" class="action">
            <i class="fa fa-trash"></i>
          </span>
          |
          <span @click="selectFile" class="action">
            <i class="fa fa-upload"></i>
          </span>
      </span>
      </li>
    </ul>

    <div v-else @click="selectFile" tabindex="0" class="add">
      <slot>
        <i class="fa fa-plus"></i>
      </slot>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import axios from "assets/js/request";
  export default {
    name: 'Uploader',
    props: {
      value: {
        type: String
      }
    },
    data(){
      return {
        url: '',
      }
    },
    created() {
      this.url = this.value;
    },
    watch: {
      value(newVal){
        this.url = newVal
      }
    },
    methods: {
      selectFile(){
        this.$refs.file.click();
      },
      onFileChange(){
        console.log('onFileChange change')
        const files = this.$refs.file.files;
        if(files.length > 0){
          const file = files[0];
          this.url = window.URL.createObjectURL(file);

          let reader = new FileReader();
          reader.addEventListener("load",  () => {
            // 画像ファイルを base64 文字列に変換します
            this.$emit('change',{
              file: reader.result,
              url: this.url
            })
          }, false);
          reader.readAsDataURL(file)
        }else{
          this.url = '';

          this.$emit('change', {
            file: null,
            url: ''
          })
        }

      },
      addFiles(){

      },
      submitFiles(){
        let formData = new FormData();
        
        for( var i = 0; i < this.files.length; i++ ){
          let file = this.files[i];
          formData.append('files', file);
        }

        var blob = new Blob([JSON.stringify(this.reqModel)], { type: "application/json"});
        formData.append('reqModel', blob);

        axios.post( 'http://localhost:8001/master/test/uploadCsvFile',
          formData,
          {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }
        ).then(function(){
          console.log('SUCCESS!!');
        })
        .catch(function(ex){
          console.log('FAILURE!!');
        });
      },
      handleFilesUpload(){
        let uploadedFiles = this.$refs.files.files;

        for( var i = 0; i < uploadedFiles.length; i++ ){

          let fileInput = uploadedFiles[i];
          console.log(fileInput);
          // check null
          if (!fileInput) {
            alert('File is null, please choose other file.');
            return;
          }
          var filePath = fileInput.name.split('.').pop();
          console.log(filePath);
          // check extention
          // var allowedExtensions = /(\jpg|\jpeg|\png|\gif)$/i;
          // if(!allowedExtensions.exec(filePath)){
          //     alert('Please upload file having extensions .jpeg/.jpg/.png/.gif only.');
          //     fileInput.value = '';
          //     return false;
          // }
          // check size
          var maxSize = 50 * 1024 * 1024;
          if (fileInput.size >= maxSize) {
            alert('Size of file maximum is 50 MB.');
            return;
          }
          // all validation checked is ok
          this.files.push( uploadedFiles[i] );

        }
      },
      removeFile( key ) {
        this.url = '';
        this.$refs.file.value = ''

        this.$emit('input', '');
      }
    }
  }
</script>